// src/js/config/ui/toggleConfigurationSource.js

import { DOMElements } from '../dom.js';
import { handleSelectConfigChangeUI } from './handleSelectConfigChangeUI.js';

/**
 * Växlar UI mellan att välja en sparad konfiguration och att ladda upp en fil.
 * Denna version säkerställer även att rätt radioknapp är vald.
 * @param {string} sourceToShow - 'select' eller 'upload'.
 */
export function toggleConfigurationSource(sourceToShow) {
    const { 
        selectCard, uploadCard, selectConfig, configFileUpload, 
        fileNameDisplay, configPage, orderConfigSourceRadios 
    } = DOMElements;

    if (!selectCard || !uploadCard) return;

    // Steg 1: Dölj båda korten
    selectCard.classList.remove('is-active');
    uploadCard.classList.remove('is-active');

    // Steg 2: Visa rätt kort baserat på input
    if (sourceToShow === 'select') {
        selectCard.classList.add('is-active');
    } else if (sourceToShow === 'upload') {
        uploadCard.classList.add('is-active');
    }

    // Steg 3: Säkerställ att rätt radioknapp är vald
    if (orderConfigSourceRadios) {
        orderConfigSourceRadios.forEach(radio => {
            if (radio.value === sourceToShow) {
                radio.checked = true;
            }
        });
    }

    // Steg 4: Återställ fältens värden
    if (selectConfig) selectConfig.value = "default";
    if (configFileUpload) configFileUpload.value = '';
    if (fileNameDisplay) fileNameDisplay.textContent = 'No file chosen';
    
    // Steg 5: Uppdatera knapp-status (relevant för config-sidan)
    if (configPage) {
        handleSelectConfigChangeUI("default");
    }
}